import Header from '../../components/header'
import { PenLine } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import api from '../../services/axios'
import { useState, useEffect } from 'react'

const UserConfiguration = () => {

  const columns = [
    'Username','Tenants Configured', 'Stations Enabled', 'Measurement Enabled', 'Actions'
  ] 
  // const data = [
  //   {
  //     id:0,
  //     name: 'John Doe',
  //     total_tenants: '5',
  //     active_stations: '10',
  //     active_sensors: '15',
  //   },
  //   {
  //     id:1,
  //     name: 'Jane Smith',
  //     total_tenants: '3',
  //     active_stations: '7',
  //     active_sensors: '12',
  //   },
  //   {
  //     id:2,
  //     name: 'Alice Johnson',
  //     total_tenants: '8',
  //     active_stations: '15',
  //     active_sensors: '20',
  //   },
  //   {
  //     id:2,
  //     name: 'Alice Johnson',
  //     total_tenants: '8',
  //     active_stations: '15',
  //     active_sensors: '20',
  //   },
  //   {
  //     id:2,
  //     name: 'Alice Johnson',
  //     total_tenants: '8',
  //     active_stations: '15',
  //     active_sensors: '20',
  //   },
  //   {
  //     id:2,
  //     name: 'Alice Johnson',
  //     total_tenants: '8',
  //     active_stations: '15',
  //     active_sensors: '20',
  //   },
  //   {
  //     id:2,
  //     name: 'Alice Johnson',
  //     total_tenants: '8',
  //     active_stations: '15',
  //     active_sensors: '20',
  //   },
  //   {
  //     id:2,
  //     name: 'Alice Johnson',
  //     total_tenants: '8',
  //     active_stations: '15',
  //     active_sensors: '20',
  //   },
  //   {
  //     id:2,
  //     name: 'Alice Johnson12',
  //     total_tenants: '8',
  //     active_stations: '15',
  //     active_sensors: '20',
  //   },
  //   {
  //     id:2,
  //     name: 'Alice Johnson12',
  //     total_tenants: '8',
  //     active_stations: '15',
  //     active_sensors: '20',
  //   },
  //   {
  //     id:2,
  //     name: 'Alice Johnson12',
  //     total_tenants: '8',
  //     active_stations: '15',
  //     active_sensors: '20',
  //   },
  // ] 
  const navigate = useNavigate();
  const [data, setData] = useState([])

  const fetchData = async() => {
    try {
      const res = await api.get('config/get-all-users');
      setData(res.data)
      console.log(res.data.data);
      setData([...res.data.data])
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, [])
  

  return (
    <div className="h-screen font-poppins flex flex-col overflow-hidden bg-base-100 dark:bg-gray-900">
      {/* Header */}
      <Header />
      {/* Main Content */}
      <div className="flex-1 flex flex-col gap-3 p-10 overflow-hidden">
        <h1 className="text-lg font-medium py-4 text-black dark:text-white border-b border-[#E8E8E8] dark:border-gray-700">User Wise Configuration</h1>
        <div className='h-full overflow-auto'>
          <div className="h-full overflow-auto">
            <table className="table table-zebra w-full">
            <thead>
              <tr>
                {columns.map((col, index) => (
                  <th key={index} className="!bg-base-200 dark:!bg-gray-800 text-base-content dark:text-gray-200 font-medium text-sm">{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={row.id} 
                    className={`
                      ${index % 2 === 0 
                        ? '!bg-base-100 dark:!bg-gray-900' 
                        : '!bg-base-200 dark:!bg-gray-800'
                      } 
                      hover:!bg-base-300 dark:hover:!bg-gray-700 
                      text-base-content dark:text-gray-300 
                      transition-colors duration-200`}
                >
                  <td className="dark:text-gray-300">{row.name}</td>
                  <td className="dark:text-gray-300">{row.total_tenants}</td>
                  <td className="dark:text-gray-300">{row.active_stations}</td>
                  <td className="dark:text-gray-300">{row.active_sensors}</td>
                  <td>
                    <button 
                      className="btn btn-sm btn-ghost hover:!bg-base-300 dark:hover:!bg-gray-600 mr-2 capitalize flex items-center gap-1 font-medium dark:text-gray-300"
                      onClick={() => navigate(`/admin/edit-user-configuration/${row.id}`)}
                    >
                      <PenLine size={12}/>
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserConfiguration